import { SettingsPanelConfig } from './SETTINGS-PANEL-CONFIG';
import { useSettingsPanelStore } from './store';

export const toggleGlobalSettingsPanel = (panelId: SettingsPanelConfig) => {
  useSettingsPanelStore.getState().setOpenGlobalPanel(panelId, (prevState) => !prevState);
};
export const closeGlobalSettingsPanel = (panelId: SettingsPanelConfig) => {
  useSettingsPanelStore.getState().setOpenGlobalPanel(panelId, false);
};
export const openGlobalSettingsPanel = (panelId: SettingsPanelConfig) => {
  useSettingsPanelStore.getState().setOpenGlobalPanel(panelId, true);
};
export const isGlobalSettingsPanelOpen = (panelId: SettingsPanelConfig) => {
  return !!useSettingsPanelStore.getState().openGlobalPanels[panelId];
};

export const enableSettingsForceTray = () => {
  useSettingsPanelStore.getState().setForceTray(true);
};

export const disableSettingsForceTray = () => {
  useSettingsPanelStore.getState().setForceTray(false);
};

export const toggleSettingsForceTray = () => {
  const currentState = useSettingsPanelStore.getState().forceTray;
  useSettingsPanelStore.getState().setForceTray(!currentState);
};

export const isSettingsForceTrayEnabled = () => {
  return useSettingsPanelStore.getState().forceTray;
};

export const GlobalSettingsPanel = {
  toggle: toggleGlobalSettingsPanel,
  close: closeGlobalSettingsPanel,
  open: openGlobalSettingsPanel,
  isOpen: isGlobalSettingsPanelOpen,
};

export const SettingsPanelEngine = {
  enableForceTray: enableSettingsForceTray,
  disableForceTray: disableSettingsForceTray,
  toggleForceTray: toggleSettingsForceTray,
  isForceTrayEnabled: isSettingsForceTrayEnabled,
};
